import React, { useState, useEffect } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import Select from 'react-select'
import Cookies from 'universal-cookie'

const SubirInventario = ({ urlProductos, setFuncion, baseUrl }) => {
    const [productos, setProductos] = useState([])
    const [registro, setRegistro] = useState({})
    const [alerta, setAlerta] = useState()
    const [atributos, setAtributos] = useState()
    const [productoSeleccionado, setProductoSeleccionado] = useState()
    const [atributoSeleccionado, setAtributoSeleccionado] = useState()
    const [opcionesAtributoSeleccionado, setOpcionesAtributoSeleccionado] = useState()
    const [opcionesAtributos, setOpcionesAtributos] = useState()
    const cookies = new Cookies()

    useEffect(() => {
        peticionTraeDatos()
    }, [])

    const peticionTraeDatos = async () => {
        try {
            const { data } = await axios.get(urlProductos, { params: { pos: 'true' } })
        
            if (data) {
                let arr = []
                data.map(item => {
                    const validarInventario = String(item.inventario) == "true" ? true : false
                    if (!validarInventario) return null;
                    let ArrFormt = item.atributos !== '' ? JSON.parse(item.atributos) : ''
                    if (ArrFormt) {
                        item['atributos'] = ArrFormt
                    }
                    item['label'] = item.nombre_producto
                    item['value'] = item.id

                    arr.push(item)
                })
                setProductos(arr)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleProductoSeleccionado = (e) => {

        setProductoSeleccionado(e)
        if (e.atributos.length > 0 && String(e.combo) == "false") {
            const atributos = []
            e.atributos.map(atri => {
                atributos.push({ ...atri, value: atri.nombre, label: atri.nombre })
            })
            return setAtributos(atributos)
        }

        setAtributos(null)
        setOpcionesAtributos(null)
        setAtributoSeleccionado(null)
        setOpcionesAtributoSeleccionado(null)
    }

    const handleSelecionarAtributo = e => {
        setAtributoSeleccionado(e)
        if (e.opciones.length > 0) {
            const opciones = []
            e.opciones.map(op => {
                if (op) {
                    opciones.push({ ...op, value: op.opcion, label: op.opcion })
                }
            })
            return setOpcionesAtributos(opciones)
        }

        setOpcionesAtributos(null)
        setOpcionesAtributoSeleccionado(null)
    }
    const handleOpcionesAtributo = (e) => {
        setOpcionesAtributoSeleccionado(e)
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        try {

            const { cantidad, costo } = registro;
            if (cantidad == "0") return setAlerta(true)
            if (costo == "0") return setAlerta(true)
            if (!productoSeleccionado) return setAlerta(true)

            let formData = new FormData()
            formData.append('producto', productoSeleccionado.id)
            formData.append('atributo', atributoSeleccionado ? atributoSeleccionado.value : '')
            formData.append('opciones', opcionesAtributoSeleccionado ? opcionesAtributoSeleccionado.value : '')
            formData.append('usuario', cookies.get('id'))
            formData.append('cantidad', cantidad)
            formData.append('costo', 0)
            formData.append('nombre', productoSeleccionado.nombre_producto)
            formData.append('METHOD', 'POST')
            const { data } = await axios.post(baseUrl, formData)
            setFuncion('ver')

            setAlerta(false)
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <form onSubmit={onSubmit}>
            <div>
                <h4>Subir Inventario</h4>
                <hr />

                <Select
                    onChange={handleProductoSeleccionado}
                    options={productos}
                    placeholder="Selecciona un producto"
                    className='mb-4'
                    required
                />
                {atributos ?
                    <Select
                        onChange={handleSelecionarAtributo}
                        options={atributos}
                        placeholder="Selecciona un atributo"
                        className='mb-4'
                        required
                    /> : null}


                {opcionesAtributos ?
                    <Select
                        onChange={handleOpcionesAtributo}
                        options={opcionesAtributos}
                        placeholder="Selecciona una opcion"
                        required
                    /> : null}

                <MDBInput
                    label={`Cantidad`}
                    value={registro.cantidad}
                    onChange={e => setRegistro({ ...registro, cantidad: e.target.value })}
                    name="cantidad"
                    required
                    outline />




                {alerta ? <p className="error">¡Llena todos los campos o la Cantidad o costo deben ser mayor a 0!!</p> : <span></span>}

                <div className="col text-center">

                    <button
                        type='submit'
                        className="btn boton_estandar"
                    >Subir Inventario
                    </button>
                    <button
                        onClick={e => setFuncion('ver')}
                        className="btn boton_estandar"
                    >Cancelar
                    </button>

                </div>
            </div>
        </form>
    )
}

export default SubirInventario